import React from 'react';
import { Rnd } from 'react-rnd';
import { PageElement } from '../types/types';

interface CoverPageProps {
  DataFrontPage: PageElement[];
  A4_WIDTH: number;
  A4_HEIGHT: number;
  marginSuperior: number;
  marginInferior: number;
  marginEsquerda: number;
  marginDireita: number;
  selectedElement: number | null;
  setSelectedElement: (index: number | null) => void;
  handleDragStopCover: (index: number, position: { x: number; y: number }) => void;
  handleResizeCover: (index: number, ref: HTMLElement, position: { x: number; y: number }) => void;
}

export const CoverPage: React.FC<CoverPageProps> = ({
  DataFrontPage,
  A4_WIDTH,
  A4_HEIGHT,
  marginSuperior,
  marginInferior,
  marginEsquerda,
  marginDireita,
  selectedElement,
  setSelectedElement,
  handleDragStopCover,
  handleResizeCover,
}) => {


  return (
    <div
      className="a4-page border rounded mx-auto"
      style={{
        width: A4_WIDTH,
        height: A4_HEIGHT,
        position: "relative",
        background: "#fff",
        padding: `${marginSuperior}px ${marginDireita}px ${marginInferior}px ${marginEsquerda}px`,
        marginBottom: "20px",
      }}
    >
      {DataFrontPage.map((element: PageElement, index: number) => (
        <Rnd
          key={`cover-element-${index}`}
          position={{ x: element.x, y: element.y }}
          size={{ width: element.width, height: element.height }}
          bounds="parent"
          onDragStop={(e, d) => handleDragStopCover(index, d)}
          onResizeStop={(e, direction, ref, delta, position) =>
            handleResizeCover(index, ref, position)
          }
          style={{
            border:
              selectedElement === index
                ? "2px solid #0d6efd"
                : "1px solid transparent",
            cursor: "move",
          }}
          onClick={() => setSelectedElement(index)}
        >
          <div
            style={{ width: "100%", height: "100%" }}
            dangerouslySetInnerHTML={{ __html: element.element }}
          />
        </Rnd>
      ))}
    </div>
  );
};